import { useTranslation } from 'react-i18next';

const steps = [
  { key: '1', icon: 'ri-search-line' },
  { key: '2', icon: 'ri-file-list-3-line' },
  { key: '3', icon: 'ri-exchange-line' },
  { key: '4', icon: 'ri-check-double-line' },
];

export default function HowItWorksSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
              {t('how_title')}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
            {steps.map((step, index) => (
              <div key={step.key} className="relative">
                <div className="bg-white rounded-xl p-6 border border-background-200 h-full">
                  <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                    <i className={`${step.icon} w-6 h-6 flex items-center justify-center text-primary-500 text-xl`} />
                  </div>
                  <div className="w-7 h-7 rounded-full bg-primary-500 text-white text-xs font-bold flex items-center justify-center mb-3">
                    {step.key}
                  </div>
                  <h3 className="font-semibold text-sm text-foreground-900 mb-2">
                    {t(`how_step${step.key}_title`)}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {t(`how_step${step.key}_desc`)}
                  </p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center text-foreground-300 text-lg" />
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors"
            >
              {t('how_cta')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}